
/**
 * Action types.
 *
 * @type {Object}
 */
export const TYPES = {
	GET_ACTIVE_COMPONENTS: 'GET_ACTIVE_COMPONENTS',
	FETCH_FROM_API: 'FETCH_FROM_API',
};
